export function getItemPath(param) {
    let { type, authUserName, team, organization, username } = param;
    if (type === 'team') {
        return "/org/".concat(organization, "/settings/teams/").concat(team);
    }
    return authUserName === username ? '/profile' : "/profile/".concat(username);
}
